export function filterKeys<T extends Record<string, any>>(obj: T, filter: (key: string) => boolean): T {
  return Object.fromEntries(Object.entries(obj).filter(([key]) => filter(key))) as T
}
